import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initAutoVersionChecker } from './utils/versionCheck';

// Automatically detect new deployments and force a clean refresh on next launch
initAutoVersionChecker();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
